// Generated by scripts/holidays.mjs from mehr-schulferien.de – do not edit by hand.
// Years 2026–2028. Run `npm run holidays -w @shh/shared -- <from> <to>` to refresh.
import type { Region, VacationKey } from './index';

export const HOLIDAY_YEARS = [2026, 2028] as const;

/** School holidays per state: [first day, last day, kind]. */
export const SCHOOL_HOLIDAYS: Record<Region, [string, string, VacationKey][]> = {
  BW: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-03-30', '2026-04-11', 'easter'],
    ['2026-05-26', '2026-06-05', 'whitsun'],
    ['2026-07-30', '2026-09-12', 'summer'],
    ['2026-10-26', '2026-10-30', 'autumn'],
    ['2026-10-31', '2026-10-31', 'autumn'],
    ['2026-12-23', '2027-01-09', 'christmas'],
    ['2027-02-08', '2027-02-12', 'easter'],
    ['2027-03-25', '2027-03-25', 'easter'],
    ['2027-03-30', '2027-04-03', 'easter'],
    ['2027-05-18', '2027-05-29', 'whitsun'],
    ['2027-07-29', '2027-09-11', 'summer'],
    ['2027-11-02', '2027-11-06', 'autumn'],
    ['2027-12-23', '2028-01-08', 'christmas'],
    ['2028-02-28', '2028-03-03', 'easter'],
    ['2028-04-13', '2028-04-13', 'easter'],
    ['2028-04-18', '2028-04-22', 'easter'],
    ['2028-06-06', '2028-06-17', 'whitsun'],
    ['2028-07-27', '2028-09-09', 'summer'],
  ],
  BY: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-02-16', '2026-02-20', 'spring'],
    ['2026-03-30', '2026-04-10', 'easter'],
    ['2026-05-26', '2026-06-05', 'whitsun'],
    ['2026-08-03', '2026-09-14', 'summer'],
    ['2026-11-02', '2026-11-06', 'autumn'],
    ['2026-12-24', '2027-01-08', 'christmas'],
    ['2027-02-08', '2027-02-12', 'spring'],
    ['2027-03-22', '2027-04-02', 'easter'],
    ['2027-05-18', '2027-05-28', 'whitsun'],
    ['2027-08-02', '2027-09-13', 'summer'],
    ['2027-11-02', '2027-11-05', 'autumn'],
    ['2027-12-24', '2028-01-07', 'christmas'],
    ['2028-02-28', '2028-03-03', 'spring'],
    ['2028-04-10', '2028-04-21', 'easter'],
    ['2028-06-06', '2028-06-16', 'whitsun'],
    ['2028-07-31', '2028-09-11', 'summer'],
  ],
  BE: [
    ['2025-12-22', '2026-01-02', 'christmas'],
    ['2026-02-02', '2026-02-07', 'winter'],
    ['2026-03-30', '2026-04-10', 'easter'],
    ['2026-05-15', '2026-05-15', 'dayOff'],
    ['2026-05-26', '2026-05-26', 'whitsun'],
    ['2026-07-09', '2026-08-22', 'summer'],
    ['2026-10-19', '2026-10-31', 'autumn'],
    ['2026-12-23', '2027-01-02', 'christmas'],
    ['2027-02-01', '2027-02-06', 'winter'],
    ['2027-03-22', '2027-04-02', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-05-18', '2027-05-19', 'whitsun'],
    ['2027-07-01', '2027-08-14', 'summer'],
    ['2027-10-11', '2027-10-23', 'autumn'],
    ['2027-12-22', '2027-12-31', 'christmas'],
    ['2028-01-31', '2028-02-05', 'winter'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-06-01', '2028-06-02', 'whitsun'],
    ['2028-07-01', '2028-08-12', 'summer'],
  ],
  BB: [
    ['2025-12-22', '2026-01-02', 'christmas'],
    ['2026-02-02', '2026-02-07', 'winter'],
    ['2026-03-30', '2026-04-10', 'easter'],
    ['2026-05-26', '2026-05-26', 'whitsun'],
    ['2026-07-09', '2026-08-22', 'summer'],
    ['2026-10-19', '2026-10-30', 'autumn'],
    ['2026-12-23', '2027-01-02', 'christmas'],
    ['2027-02-01', '2027-02-06', 'winter'],
    ['2027-03-22', '2027-04-03', 'easter'],
    ['2027-05-18', '2027-05-18', 'whitsun'],
    ['2027-07-01', '2027-08-14', 'summer'],
    ['2027-10-11', '2027-10-23', 'autumn'],
    ['2027-12-23', '2027-12-31', 'christmas'],
    ['2028-01-31', '2028-02-05', 'winter'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-06-29', '2028-08-12', 'summer'],
  ],
  HB: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-02-02', '2026-02-03', 'winter'],
    ['2026-03-23', '2026-04-07', 'easter'],
    ['2026-05-15', '2026-05-15', 'ascension'],
    ['2026-05-26', '2026-05-26', 'whitsun'],
    ['2026-07-02', '2026-08-12', 'summer'],
    ['2026-10-12', '2026-10-24', 'autumn'],
    ['2026-12-23', '2027-01-09', 'christmas'],
    ['2027-02-01', '2027-02-02', 'winter'],
    ['2027-03-22', '2027-04-03', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-05-18', '2027-05-18', 'whitsun'],
    ['2027-07-08', '2027-08-18', 'summer'],
    ['2027-10-18', '2027-10-30', 'autumn'],
    ['2027-12-23', '2028-01-08', 'christmas'],
    ['2028-01-31', '2028-02-01', 'winter'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-06-06', '2028-06-06', 'whitsun'],
    ['2028-07-20', '2028-08-30', 'summer'],
  ],
  HH: [
    ['2025-12-17', '2026-01-02', 'christmas'],
    ['2026-01-30', '2026-01-30', 'dayOff'],
    ['2026-03-02', '2026-03-13', 'spring'],
    ['2026-05-11', '2026-05-15', 'ascension'],
    ['2026-07-09', '2026-08-19', 'summer'],
    ['2026-10-19', '2026-10-30', 'autumn'],
    ['2026-12-21', '2027-01-01', 'christmas'],
    ['2027-01-29', '2027-01-29', 'winter'],
    ['2027-03-01', '2027-03-12', 'spring'],
    ['2027-05-07', '2027-05-14', 'ascension'],
    ['2027-07-01', '2027-08-11', 'summer'],
    ['2027-10-11', '2027-10-22', 'autumn'],
    ['2027-12-20', '2027-12-31', 'christmas'],
    ['2028-01-28', '2028-01-28', 'winter'],
    ['2028-03-06', '2028-03-17', 'spring'],
    ['2028-05-22', '2028-05-26', 'ascension'],
    ['2028-07-03', '2028-08-11', 'summer'],
  ],
  HE: [
    ['2025-12-22', '2026-01-10', 'christmas'],
    ['2026-03-30', '2026-04-10', 'easter'],
    ['2026-06-29', '2026-08-07', 'summer'],
    ['2026-10-05', '2026-10-17', 'autumn'],
    ['2026-12-23', '2027-01-12', 'christmas'],
    ['2027-03-22', '2027-04-02', 'easter'],
    ['2027-06-28', '2027-08-06', 'summer'],
    ['2027-10-04', '2027-10-16', 'autumn'],
    ['2027-12-23', '2028-01-11', 'christmas'],
    ['2028-04-03', '2028-04-14', 'easter'],
    ['2028-07-03', '2028-08-11', 'summer'],
  ],
  MV: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-02-09', '2026-02-20', 'winter'],
    ['2026-03-30', '2026-04-08', 'easter'],
    ['2026-05-15', '2026-05-15', 'dayOff'],
    ['2026-05-22', '2026-05-26', 'whitsun'],
    ['2026-07-13', '2026-08-22', 'summer'],
    ['2026-10-15', '2026-10-24', 'autumn'],
    ['2026-12-21', '2027-01-02', 'christmas'],
    ['2027-02-08', '2027-02-19', 'winter'],
    ['2027-03-24', '2027-04-02', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-05-14', '2027-05-18', 'whitsun'],
    ['2027-07-05', '2027-08-14', 'summer'],
    ['2027-10-14', '2027-10-23', 'autumn'],
    ['2027-12-22', '2028-01-04', 'christmas'],
    ['2028-02-05', '2028-02-17', 'winter'],
    ['2028-02-18', '2028-02-18', 'winter'],
    ['2028-04-12', '2028-04-21', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-06-02', '2028-06-06', 'whitsun'],
    ['2028-06-26', '2028-08-05', 'summer'],
  ],
  NI: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-02-02', '2026-02-03', 'winter'],
    ['2026-03-23', '2026-04-07', 'easter'],
    ['2026-05-15', '2026-05-15', 'ascension'],
    ['2026-05-26', '2026-05-26', 'whitsun'],
    ['2026-07-02', '2026-08-12', 'summer'],
    ['2026-10-12', '2026-10-24', 'autumn'],
    ['2026-12-23', '2027-01-09', 'christmas'],
    ['2027-02-01', '2027-02-02', 'winter'],
    ['2027-03-22', '2027-04-03', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-05-18', '2027-05-18', 'whitsun'],
    ['2027-07-08', '2027-08-18', 'summer'],
    ['2027-10-16', '2027-10-30', 'autumn'],
    ['2027-12-23', '2028-01-08', 'christmas'],
    ['2028-01-31', '2028-02-01', 'winter'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-06-06', '2028-06-06', 'whitsun'],
    ['2028-07-20', '2028-08-30', 'summer'],
  ],
  NW: [
    ['2025-12-22', '2026-01-06', 'christmas'],
    ['2026-03-30', '2026-04-11', 'easter'],
    ['2026-05-26', '2026-05-26', 'whitsun'],
    ['2026-07-20', '2026-09-01', 'summer'],
    ['2026-10-17', '2026-10-31', 'autumn'],
    ['2026-12-23', '2027-01-06', 'christmas'],
    ['2027-03-22', '2027-04-03', 'easter'],
    ['2027-05-18', '2027-05-18', 'whitsun'],
    ['2027-07-19', '2027-08-31', 'summer'],
    ['2027-10-23', '2027-11-06', 'autumn'],
    ['2027-12-24', '2028-01-08', 'christmas'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-07-10', '2028-08-22', 'summer'],
  ],
  RP: [
    ['2025-12-22', '2026-01-07', 'christmas'],
    ['2026-03-30', '2026-04-10', 'easter'],
    ['2026-06-29', '2026-08-07', 'summer'],
    ['2026-10-05', '2026-10-16', 'autumn'],
    ['2026-12-23', '2027-01-08', 'christmas'],
    ['2027-03-22', '2027-04-02', 'easter'],
    ['2027-06-28', '2027-08-06', 'summer'],
    ['2027-10-04', '2027-10-15', 'autumn'],
    ['2027-12-23', '2028-01-07', 'christmas'],
    ['2028-04-10', '2028-04-21', 'easter'],
    ['2028-07-03', '2028-08-11', 'summer'],
  ],
  SL: [
    ['2025-12-22', '2026-01-02', 'christmas'],
    ['2026-02-16', '2026-02-20', 'winter'],
    ['2026-04-07', '2026-04-17', 'easter'],
    ['2026-06-29', '2026-08-07', 'summer'],
    ['2026-10-05', '2026-10-16', 'autumn'],
    ['2026-12-21', '2026-12-31', 'christmas'],
    ['2027-02-08', '2027-02-12', 'winter'],
    ['2027-03-30', '2027-04-09', 'easter'],
    ['2027-06-28', '2027-08-06', 'summer'],
    ['2027-10-04', '2027-10-15', 'autumn'],
    ['2027-12-20', '2027-12-31', 'christmas'],
    ['2028-02-21', '2028-02-29', 'winter'],
    ['2028-04-12', '2028-04-21', 'easter'],
    ['2028-07-03', '2028-08-11', 'summer'],
  ],
  SN: [
    ['2025-12-22', '2026-01-02', 'christmas'],
    ['2026-02-09', '2026-02-21', 'winter'],
    ['2026-04-03', '2026-04-10', 'easter'],
    ['2026-05-15', '2026-05-15', 'dayOff'],
    ['2026-07-04', '2026-08-14', 'summer'],
    ['2026-10-12', '2026-10-24', 'autumn'],
    ['2026-12-23', '2027-01-02', 'christmas'],
    ['2027-02-08', '2027-02-19', 'winter'],
    ['2027-03-26', '2027-04-02', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-05-15', '2027-05-18', 'whitsun'],
    ['2027-07-10', '2027-08-20', 'summer'],
    ['2027-10-11', '2027-10-23', 'autumn'],
    ['2027-12-23', '2028-01-01', 'christmas'],
    ['2028-02-14', '2028-02-26', 'winter'],
    ['2028-04-14', '2028-04-22', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-07-22', '2028-09-01', 'summer'],
  ],
  ST: [
    ['2025-12-22', '2026-01-05', 'christmas'],
    ['2026-01-31', '2026-02-06', 'winter'],
    ['2026-03-30', '2026-04-04', 'easter'],
    ['2026-05-26', '2026-05-29', 'whitsun'],
    ['2026-07-04', '2026-08-14', 'summer'],
    ['2026-10-19', '2026-10-30', 'autumn'],
    ['2026-12-21', '2027-01-02', 'christmas'],
    ['2027-02-01', '2027-02-06', 'winter'],
    ['2027-03-22', '2027-03-27', 'easter'],
    ['2027-05-15', '2027-05-22', 'whitsun'],
    ['2027-07-10', '2027-08-20', 'summer'],
    ['2027-10-18', '2027-10-23', 'autumn'],
    ['2027-12-20', '2027-12-31', 'christmas'],
    ['2028-02-07', '2028-02-12', 'winter'],
    ['2028-04-10', '2028-04-22', 'easter'],
    ['2028-06-03', '2028-06-10', 'whitsun'],
    ['2028-07-22', '2028-09-01', 'summer'],
  ],
  SH: [
    ['2025-12-19', '2026-01-06', 'christmas'],
    ['2026-03-26', '2026-04-10', 'easter'],
    ['2026-05-15', '2026-05-15', 'ascension'],
    ['2026-07-04', '2026-08-15', 'summer'],
    ['2026-10-12', '2026-10-24', 'autumn'],
    ['2026-12-21', '2027-01-06', 'christmas'],
    ['2027-03-30', '2027-04-10', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-07-03', '2027-08-14', 'summer'],
    ['2027-10-11', '2027-10-23', 'autumn'],
    ['2027-12-23', '2028-01-08', 'christmas'],
    ['2028-04-03', '2028-04-15', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-06-24', '2028-08-04', 'summer'],
  ],
  TH: [
    ['2025-12-22', '2026-01-03', 'christmas'],
    ['2026-02-16', '2026-02-21', 'winter'],
    ['2026-04-07', '2026-04-17', 'easter'],
    ['2026-05-15', '2026-05-15', 'dayOff'],
    ['2026-07-04', '2026-08-14', 'summer'],
    ['2026-10-12', '2026-10-24', 'autumn'],
    ['2026-12-23', '2027-01-02', 'christmas'],
    ['2027-02-01', '2027-02-06', 'winter'],
    ['2027-03-22', '2027-04-03', 'easter'],
    ['2027-05-07', '2027-05-07', 'ascension'],
    ['2027-07-10', '2027-08-20', 'summer'],
    ['2027-10-09', '2027-10-23', 'autumn'],
    ['2027-12-23', '2027-12-31', 'christmas'],
    ['2028-02-07', '2028-02-12', 'winter'],
    ['2028-04-03', '2028-04-15', 'easter'],
    ['2028-05-26', '2028-05-26', 'ascension'],
    ['2028-07-22', '2028-09-01', 'summer'],
  ],
};

/** Public holidays per state: [day, German name]. */
export const PUBLIC_HOLIDAYS: Record<Region, [string, string][]> = {
  BW: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-01-06', 'Heilige Drei Könige'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-11-01', 'Allerheiligen'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-01-06', 'Heilige Drei Könige'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-11-01', 'Allerheiligen'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-01-06', 'Heilige Drei Könige'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-11-01', 'Allerheiligen'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  BY: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-01-06', 'Heilige Drei Könige'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-11-01', 'Allerheiligen'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-01-06', 'Heilige Drei Könige'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-11-01', 'Allerheiligen'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-01-06', 'Heilige Drei Könige'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-11-01', 'Allerheiligen'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  BE: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-03-08', 'Frauentag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-08', 'Frauentag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-03-08', 'Frauentag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-17', '75. Jahrestag Volksaufstand 17. Juni'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  BB: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-05', 'Ostersonntag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-24', 'Pfingstsonntag'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-28', 'Ostersonntag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-16', 'Pfingstsonntag'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-16', 'Ostersonntag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-04', 'Pfingstsonntag'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  HB: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  HH: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  HE: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  MV: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-03-08', 'Frauentag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-08', 'Frauentag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-03-08', 'Frauentag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  NI: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  NW: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-11-01', 'Allerheiligen'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-11-01', 'Allerheiligen'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-11-01', 'Allerheiligen'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  RP: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-11-01', 'Allerheiligen'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-11-01', 'Allerheiligen'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-11-01', 'Allerheiligen'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  SL: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-06-04', 'Fronleichnam'],
    ['2026-08-15', 'Mariä Himmelfahrt'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-11-01', 'Allerheiligen'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-05-27', 'Fronleichnam'],
    ['2027-08-15', 'Mariä Himmelfahrt'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-11-01', 'Allerheiligen'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-06-15', 'Fronleichnam'],
    ['2028-08-15', 'Mariä Himmelfahrt'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-11-01', 'Allerheiligen'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  SN: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-11-18', 'Buß- und Bettag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-11-17', 'Buß- und Bettag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-11-22', 'Buß- und Bettag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  ST: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-01-06', 'Heilige Drei Könige'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-01-06', 'Heilige Drei Könige'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-01-06', 'Heilige Drei Könige'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  SH: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
  TH: [
    ['2026-01-01', 'Neujahrstag'],
    ['2026-04-03', 'Karfreitag'],
    ['2026-04-06', 'Ostermontag'],
    ['2026-05-01', 'Tag der Arbeit'],
    ['2026-05-14', 'Christi Himmelfahrt'],
    ['2026-05-25', 'Pfingstmontag'],
    ['2026-09-20', 'Weltkindertag'],
    ['2026-10-03', 'Tag der Deutschen Einheit'],
    ['2026-10-31', 'Reformationstag'],
    ['2026-12-25', '1. Weihnachtstag'],
    ['2026-12-26', '2. Weihnachtstag'],
    ['2027-01-01', 'Neujahrstag'],
    ['2027-03-26', 'Karfreitag'],
    ['2027-03-29', 'Ostermontag'],
    ['2027-05-01', 'Tag der Arbeit'],
    ['2027-05-06', 'Christi Himmelfahrt'],
    ['2027-05-17', 'Pfingstmontag'],
    ['2027-09-20', 'Weltkindertag'],
    ['2027-10-03', 'Tag der Deutschen Einheit'],
    ['2027-10-31', 'Reformationstag'],
    ['2027-12-25', '1. Weihnachtstag'],
    ['2027-12-26', '2. Weihnachtstag'],
    ['2028-01-01', 'Neujahrstag'],
    ['2028-04-14', 'Karfreitag'],
    ['2028-04-17', 'Ostermontag'],
    ['2028-05-01', 'Tag der Arbeit'],
    ['2028-05-25', 'Christi Himmelfahrt'],
    ['2028-06-05', 'Pfingstmontag'],
    ['2028-09-20', 'Weltkindertag'],
    ['2028-10-03', 'Tag der Deutschen Einheit'],
    ['2028-10-31', 'Reformationstag'],
    ['2028-12-25', '1. Weihnachtstag'],
    ['2028-12-26', '2. Weihnachtstag'],
  ],
};
